import React from 'react';
import Workshops from '../../components/Workshops';

const WorkshopsPage: () => JSX.Element = () => (<Workshops />);

export default WorkshopsPage;
